import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const addSupplySubCategoryMutation = gql`mutation addSupplySubCategory($supplySubCategory: supply_sub_categories_insert_input!){
  insert_supply_sub_categories_one(object: $supplySubCategory){
    id
    name
    created_at
    updated_at
    supply_category_id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class AddSupplySubCategoryService {

  constructor(
    private apollo: Apollo
  ) { }

  addSupplySubCategory(supplySubCategory: any){
    return this.apollo.use('external').mutate({
      mutation: addSupplySubCategoryMutation,
      variables: {
        supplySubCategory
      }
    }).pipe(pluck('data', 'insert_supply_sub_categories_one')).toPromise();
  }
}

